import DashboardTaskStatus from '../components/Dashboard/DashboardTaskStatus';
import DashboardUserAssignedTasks from '../components/Dashboard/DashboardUserAssignedTasks';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import React from 'react';
import DashboardRiskLevel from '../components/Dashboard/DashboardRiskLevel';
import DashboardRiskByDepartment from '../components/Dashboard/DashboardRiskByDepartment';
import DashboardTaskDueDateSummary from '../components/Dashboard/DashboardTaskDueDateSummary';

export function getDefaultDashboardWidgetSettings(componentType) {
    switch (componentType) {
        case 'DashboardTaskStatus':
        case 'DashboardTaskSummary':
            return { excludedStatusIds: [] };
        case 'DashboardUserAssignedTasks':
            return { excludedStatusIds: [9] };
        case 'DashboardTaskDueDateSummary':
            return { excludedStatusIds: [9] };
        case 'DashboardRiskByDepartment':
            return { groupBy: 'department' };
        default:
            return {};
    }
}

export function getDefaultDashboardWidgetJsonSettings(componentType) {
    return JSON.stringify(getDefaultDashboardWidgetSettings(componentType));
}

export function getDashboardWidgetComponent(componentType, jsonSettings, onSettingsChange) {
    switch (componentType) {
        case 'DashboardTaskStatus':
        case 'DashboardTaskSummary':
            return <DashboardTaskStatus jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        case 'DashboardUserAssignedTasks':
            return <DashboardUserAssignedTasks jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        case 'DashboardRiskLevel':
            return <DashboardRiskLevel jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        case 'DashboardRiskByDepartment':
            return <DashboardRiskByDepartment jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        case 'DashboardTaskDueDateSummary':
            return <DashboardTaskDueDateSummary jsonSettings={jsonSettings} onSettingsChange={onSettingsChange} />;
        default:
            return <AddCircleOutlineIcon style={{ fontSize: 80 }} />;
    }
}

export function getBaseDashboardComponents() {
    return [
        { id: 'box1', position: 0 },
        { id: 'box2', position: 1 },
        { id: 'box3', position: 2 },
        { id: 'box4', position: 3 },
    ];
}

export function getDefaultDashboardWidgets() {
    return [
        {
            id: 'box1',
            position: 0,
            component: 'DashboardTaskStatus',
            name: 'DashboardTaskStatus',
            jsonSettings: getDefaultDashboardWidgetJsonSettings('DashboardTaskStatus')
        },
        {
            id: 'box2',
            position: 1,
            component: 'DashboardUserAssignedTasks',
            name: 'DashboardUserAssignedTasks',
            jsonSettings: getDefaultDashboardWidgetJsonSettings('DashboardUserAssignedTasks')
        },
    ];
}
